import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  confirmExport(e) {
    const confirmed = window.confirm('表示されている在庫情報をCSV出力します。')

    if (!confirmed) {
      e.preventDefault()
      return false
    }

    // 確認後、フォーム送信を許可
    // CSVダウンロード後に成功メッセージを表示
    setTimeout(() => {
      const message = this.element.dataset.successMessage || '在庫情報CSV出力が完了しました。'
      window.alert(message)
    }, 1000)

    return true
  }
}
